//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { WestfieldDirectReturnsMediumSVG } from './svg'

interface WestfieldDirectReturnsMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
}

export const WestfieldDirectReturnsMediumIcon: React.FC<WestfieldDirectReturnsMediumIconProps> = forwardRef<
  WestfieldDirectReturnsMediumIconProps,
  typeof ChakraIcon
>(({ boxSize = 'size-icon-sm', sx }, ref) => (
  <ChakraIcon
    ref={ref}
    boxSize={boxSize}
    as={WestfieldDirectReturnsMediumSVG}
    sx={sx}
  />
))
